import { illnesses } from "@api/illnesses/path";
import { hospitalization } from "@api/hospitalization/path";
import { visitSummaryNotes } from "@api/visitSummaryNotes/path";
import { surgeries } from "@api/surgeries/path";
import { allergies } from "@api/allergies/path";
import { medicines } from "@api/medicines/path";
import { familyIllnesses } from "@api/familyIllnesses/path";
import { prescriptions } from "@api/prescriptions/path";
import { infinite } from "@api/infiniteDropdowns/path";
import { reports } from "@api/reports/path";
import { msp } from "@api/msp/path";
import { roleManagement } from "@api/roleManagement/path";

export const apiPath = {
  illnesses,
  hospitalization,
  surgeries,
  allergies,
  medicines,
  familyIllnesses,
  visitSummaryNotes,
  prescriptions,
  infinite,
  reports,
  msp,
  roleManagement,
};
